import { type FC } from 'react'
import classNames from 'classnames'
import { CustomDropdownItemOption, type DropDownItemOptionComponentProps } from '../../../../components/SelectDropdown/SelectDropdown'

export const SchedulingDropdownItem: FC<DropDownItemOptionComponentProps> = ({ optionLabel, displayLabel, onClick, disabled, className }) => {
  if (disabled) {
    return <div className={classNames('px-2 py-1', className)}>{displayLabel ?? optionLabel}</div>
  }
  return (
    <CustomDropdownItemOption role='button' onClick={onClick} className={classNames('w-100', className)}>
      {displayLabel ?? optionLabel}
    </CustomDropdownItemOption>
  )
}
